export default __webpack_public_path__ + "static/media/digital-highway.c9031e6c.png";